import { IHeaderColumn } from 'Components/TableBase/SortableTableHead';

export enum EDocumentsTableColumnKeys {
  TITLE = 'title',
  CREATOR = 'creator',
  OWNER = 'owner',
  USAGE = 'usage',
  ISSUE_DATE = 'issueDate',
  EXPIRY_DATE = 'expiryDate',
  ACTIONS = 'actions',
}

export const documentsHeaderColumns: IHeaderColumn<EDocumentsTableColumnKeys>[] = [
  { id: EDocumentsTableColumnKeys.TITLE, headerName: 'Title', sortable: false },
  { id: EDocumentsTableColumnKeys.OWNER, headerName: 'Owner', sortable: false },
  { id: EDocumentsTableColumnKeys.CREATOR, headerName: 'Creator', sortable: false },
  { id: EDocumentsTableColumnKeys.USAGE, headerName: 'Usage', sortable: false },
  { id: EDocumentsTableColumnKeys.ISSUE_DATE, headerName: 'Issue date', sortable: false },
  { id: EDocumentsTableColumnKeys.EXPIRY_DATE, headerName: 'Expiry date', sortable: false },
  { id: EDocumentsTableColumnKeys.ACTIONS, headerName: 'Actions', sortable: false },
];
